import { GuidIdCodeAndLabel, GuidIdAndLabel } from '../../../integrated-client/models';
import {DEFAULT_RULE_SEARCHES_TOTAL_ITEMS} from "../../../utils/Constants";

export const RULE_SEARCHES_DEFAULT_LIMIT = 11;

export interface IRuleSearchesFormData {
  ruleId?: string
  description: string | null
  details: string | null
  supplier: GuidIdAndLabel | null
  carrier: GuidIdCodeAndLabel | null
  showDisabled: boolean
  offset: number
  limit: number | null
  total: number
  currentPage: number
}

export class RuleSearchesFormData implements IRuleSearchesFormData {

  ruleId?: string
  description: string | null
  details: string | null
  supplier: GuidIdAndLabel | null
  carrier: GuidIdCodeAndLabel | null
  showDisabled: boolean
  offset: number
  limit: number | null
  total: number
  currentPage: number


  constructor() {
    this.description = null;
    this.supplier = null;
    this.carrier = null;
    this.details = null;
    this.showDisabled = false;
    this.offset = 0;
    this.limit = RULE_SEARCHES_DEFAULT_LIMIT;
    this.total = DEFAULT_RULE_SEARCHES_TOTAL_ITEMS;
    this.currentPage = 1;
  }

}
